export default class Site {
    constructor(siteData) {
        // FIXME: Transition this to properites instead.
        this.customizations = siteData.customizations.map(c => {
            c.value = c.pivot.value ? c.pivot.value : true;
            return c;
        });
        this.data = siteData;
        this.customizations.forEach(c => {
            this[c.name] = c.value;
        });
    }
    get canInviteUsers() {
        return this.getCustomizationByName("CanInviteUsers") !== false;
    }
    get isPrivacyEnabled() {
        return this.getCustomizationByName("PrivacyEnabled") !== false;
    }
    get isTrackingLogEnabled() {
        return this.getCustomizationByName("TrackingLogEnabled") !== false;
    }
    get invitesPerUser() {
        return parseInt(this.getCustomizationValueByName("InvitesPerUser", 0));
    }
    get minimumPasswordLength() {
        return parseInt(this.getCustomizationValueByName("MinimumPasswordLength", 9));
    }
    get maximumPasswordLength() {
        return parseInt(this.getCustomizationValueByName("MaximumPasswordLength", 64));
    }
    get isWorkperksExpress() {
        return this.data.type_id === 7;
    }
    getCustomizationByName(name) {
        let customization = false;
        this.customizations.forEach(c => {
            if (c.name === name) {
                customization = c;
                return true;
            }
        });
        return customization;
    }
    has(name) {
        return this.getCustomizationByName(name) !== false;
    }
    getCustomizationValueByName(name, defaultValue = false) {
        const customization = this.getCustomizationByName(name);
        if (customization) {
            return customization.value;
        }
        return defaultValue;
    }
    static getCurrentSite() {
        return new Site(window.s.site);
    }
}
